export const validateEmail = (value: string): string | null => {
    const trimmed = value.trim();
    if (!trimmed) {
        return 'Email is required.';
    }

    const looksValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
    if (!looksValid) {
        return 'Enter a valid email address.';
    }

    return null;
};

export const validateOptionalEmail = (value: string): string | null => {
    const trimmed = value.trim();
    if (!trimmed) {
        return null;
    }

    const looksValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmed);
    if (!looksValid) {
        return 'Enter a valid email address.';
    }

    return null;
};
